
import { styled } from '@mui/material/styles'
import Switch from '@mui/material/Switch'

const MuiSwitch = styled((props) => {
  return (
    <Switch
      focusVisibleClassName=".mui-jss-Mui-focusVisible"
      disableRipple
      {...props}/>
  )
})(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .mui-jss-MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#FFF',
      '& + .mui-jss-MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .mui-jss-MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .mui-jss-MuiSwitch-thumb': {
      color: '#33CF4D',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .mui-jss-MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? '#F5F5F5'
          : '#757575',
    },
    '&.Mui-disabled + .mui-jss-MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .mui-jss-MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .mui-jss-MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

export default MuiSwitch
